//LL: 23.01.23: DST_SwitchingDaysClassField

import ParameterFieldBase, { IParameterFieldBaseOptions } from '../../../../../_common/platform/ts/ParameterFieldBase';
import EditComponent from './DST_SwitchingDaysField';

export class DST_SwitchingDaysClassField extends ParameterFieldBase<IParameterFieldBaseOptions> {
    public static defaultValidators = [];

    public static EditComponent = EditComponent;

    public static getDefaultValue() {
        return [];
    }

    constructor(glob, title: string, validators?: any, defaultVal?: any, options?) {
        if (defaultVal == null) {
            defaultVal = DST_SwitchingDaysClassField.getDefaultValue();
        }

        super(glob, title, DST_SwitchingDaysClassField.defaultValidators, validators, defaultVal, options);
    }
}
